module.exports = __webpack_public_path__ + "static/media/decorationBacgroundUpperContent.b945d398.png";